<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="msgSemResultado">
    Não foram encontrados patrimônios líquidos com os filtros informados.
  </div>

  <div *ngIf="patrimoniosLiquidos && patrimoniosLiquidos.length">
    <div class="d-flex justify-content-end">
      <button [disabled]="patrimoniosLiquidos.length == 0" class="btn btn-secondary m-0" type="button"
        (click)="btnExportarListaPatrimonioLiquido()" placement="top"
        ngbTooltip="Exporta todos os PLs listados">
        <i class="fa fa-file"></i> Exportar PL</button>
    </div>
    <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
    <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr class="text-nowrap">
              <th scope="col" class="text-center">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataBase'"
                  [nomeAtributoExibicao]="'Data Base'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="text-end">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valor'"
                  [nomeAtributoExibicao]="'Valor Patrimônio Líquido'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="text-center">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeUsuarioADResponsavel'"
                  [nomeAtributoExibicao]="'Usuário Responsável'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="text-center">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataRegistro'"
                  [nomeAtributoExibicao]="'Data Registro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col" class="text-center">
                Ação
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let patrimonioLiquido of patrimoniosLiquidos; let i = index">
              <tr *ngIf="podeCadastrar; else naoPodeCadastrarEditar" (mouseenter)="hover(i)" class="cursor-pointer"
                (mouseleave)="hoverClean()" [routerLink]="['/habilitacao/patrimonio-liquido/', patrimonioLiquido.id]">
                <td class="text-center">{{ patrimonioLiquido.dataBase | date: 'dd/MM/yyyy' }}</td>
                <td class="text-end">{{ patrimonioLiquido.valor | bnMask: 'MOEDA' }}</td>
                <td class="text-center">{{ patrimonioLiquido.nomeUsuarioADResponsavel }}</td>
                <td class="text-center">{{ patrimonioLiquido.dataRegistro | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-center">
                  <i *ngIf="rowHovered === i" class="fa fa-pen text-primary ms-4" placement="left-top"
                    ngbTooltip="Editar PL"></i>
                </td>
              </tr>
              <ng-template #naoPodeCadastrarEditar>
                <tr>
                  <td class="text-center">{{ patrimonioLiquido.dataBase | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-end">{{ patrimonioLiquido.valor | bnMask: 'MOEDA' }}</td>
                  <td class="text-center">{{ patrimonioLiquido.nomeUsuarioADResponsavel }}</td>
                  <td class="text-center">{{ patrimonioLiquido.dataRegistro | date: 'dd/MM/yyyy HH:mm' }}</td>
                  <td class="text-center"></td>
                </tr>
              </ng-template>
            </ng-container>
          </tbody>

        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
